import { kyApi } from 'api'
// ユーザ一覧CSV出力対応 CSV出力ボタン追加 20250303 原
// import { checkListDetail, checkListRitsu, checkListSummaryUser, searchJoken, searchJokenRitsu, searchUser, searchLog, searchTenyuryoku, searchJokenKura } from 'types/SearchTypes'
import { checkListDetail, checkListRitsu, checkListSummaryUser, searchJoken, searchJokenRitsu, searchUser, searchLog, searchTenyuryoku, searchJokenKura, checkListDetailUser } from 'types/SearchTypes'
// 修正CSV出力対応 修正出力ボタン追加  20250219 原
// import { requestDetailCSV, requestJokenSummary, requestUser, requestRitsu, requestRitsuCSV, requestUserUpdate, requestLog, requestTenyuryokuSummary, requestJokenDetail, requestTenyuryokuDetail, requestRitsuSearch, requestRitsuAllCSV } from 'types/RequestTypes'
// ユーザ一覧CSV出力対応 CSV出力ボタン追加 20250303 原
// import { requestDetailCSV, requestJokenSummary, requestUser, requestRitsu, requestRitsuCSV, requestUserUpdate, requestLog, requestTenyuryokuSummary, requestJokenDetail, requestTenyuryokuDetail, requestRitsuSearch, requestRitsuAllCSV, requestDetailCSV_SYUSEI } from 'types/RequestTypes'
import { requestDetailCSV, requestJokenSummary, requestUser, requestRitsu, requestRitsuCSV, requestUserUpdate, requestLog, requestTenyuryokuSummary, requestJokenDetail, requestTenyuryokuDetail, requestRitsuSearch, requestRitsuAllCSV, requestDetailCSV_SYUSEI, requestDetailUserCSV, requestSummaryUserCSV } from 'types/RequestTypes'
import { keyInfo, jotai } from 'types/ReferTypes'
// import { tanto, tokuisaki, keyInfo, jotai } from 'types/ReferTypes'
// import { commonMsg } from 'assets/MessageCode'
import { apiLog } from './logUtil'
import { getURI, zeroPadding, zeroPaddingRight } from './stringUtil'
// 修正CSV出力対応 修正出力ボタン追加  20250219 原
// import { F_NUM, HAN_KBN, KURA_KBN } from 'assets/FormatNumbers'
import { F_NUM, HAN_KBN, KURA_KBN, HAN_SYUSEI_KBN, KURA_SYUSEI_KBN } from 'assets/FormatNumbers'

/**
 * 新ライブラリAPI関数
 * ky導入に伴い入替
 */
export const postAPI = async <T extends Object, U extends Object>(
  url: string, //
  req: T,
  func: (res: { body: U; error: boolean; end: boolean; message: string; fname: string }) => void,
  errFunc: () => void = () => {},
  finalFunc: () => void = () => {},
) => {
  let isError = false
  const token = sessionStorage.getItem('token')
  await kyApi(token!)
    .post(getURI(url), {
      json: { req },
    })
    .json<{ body: U; error: boolean; end: boolean; message: string; fname: string }>()
    .then((res) => {
      if (res.end) throw new Error()
      func(res)
    })
    .catch((err: Error) => {
      console.error(err)
      errFunc()
      isError = true
    })
    .finally(() => {
      apiLog(url)
      finalFunc()
    })
  return isError
}

/**
 * リクエスト型省略版
 */
export const postAPIsimple = async <U extends Object>(
  url: string, //
  req: any,
  func: (res: { body: U; error: boolean; end: boolean; message: string; fname: string }) => void,
  errFunc: () => void = () => {},
  finalFunc: () => void = () => {},
) => {
  let isError = false
  const token = sessionStorage.getItem('token')
  await kyApi(token!)
    .post(getURI(url), {
      json: { req },
    })
    .json<{ body: U; error: boolean; end: boolean; message: string; fname: string }>()
    .then((res) => {
      if (res.end) throw new Error()
      func(res)
    })
    .catch((err: Error) => {
      console.error(err)
      errFunc()
      isError = true
    })
    .finally(() => {
      apiLog(url)
      finalFunc()
    })
  return isError
}

/**
 * フォーム送信用(リクエストをボディに入れる)
 * ファイルアップロードはこちらを使う
 */
export const postFormAPI = async <U extends Object>(
  url: string, //
  req: FormData,
  func: (res: { body: U; error: boolean; end: boolean; message: string; fname: string }) => void,
  errFunc: () => void = () => {},
  finalFunc: () => void = () => {},
) => {
  const token = sessionStorage.getItem('token')
  await kyApi(token!)
    .post(getURI(url), { body: req })
    .json<{ body: U; error: boolean; end: boolean; message: string; fname: string }>()
    .then(func)
    .catch((err: Error) => {
      console.error(err)
      errFunc()
    })
    .finally(() => {
      apiLog(url)
      finalFunc()
    })
}

export const postFetcher = <U extends Object>(url: string = '/', req: any = {}): (() => Promise<{ body: U; error: boolean; end: boolean; message: string; fname: string }>) => {
  const token = sessionStorage.getItem('token')
  return async () =>
    await kyApi(token!)
      .post(getURI(url), { json: { req } })
      .json<{ body: U; error: boolean; end: boolean; message: string; fname: string }>()
      .then((res) => res)
}

/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 販売/倉出条件
 * @returns
 */
export const getRequestJoken = (MAIL: string, keyInfo: keyInfo[], TANTO_CD: number, isSuperUser: boolean, isJocho: boolean, isKoiki: boolean, page: number, perPage: number, isHiddenPagination: boolean, INP_KBN: number, searchJoken: searchJoken | searchJokenKura): requestJokenSummary => {
  const base = {
    MAIL: MAIL,
    keyInfo: keyInfo,
    TANTO_CD: TANTO_CD,
    isSuperUser: isSuperUser,
    isJocho: isJocho,
    isKoiki: isKoiki,
    page: isHiddenPagination ? F_NUM : page,
    perPage: isHiddenPagination ? F_NUM : perPage,
    INP_KBN: INP_KBN,
    searchJoken: {
      JOKEN_KANRI_NO: zeroPadding(parseInt(searchJoken.JOKEN_KANRI_NO), 10),
      KEN_NM: searchJoken.KEN_NM,
      SIIRE_CD: searchJoken.SIIRE_CD,
      JIGYO_CD: searchJoken.JIGYO_CD,
      BUSHO_CD: searchJoken.BUSHO_CD,
      TOKUI_CD: searchJoken.TOKUI_CD,
      // TANTO_CD: F_NUM,
      TEKIYO_START_DT: searchJoken.TEKIYO_START_DT,
      TEKIYO_END_DT: searchJoken.TEKIYO_END_DT,
      ADD_TANTO_CD: searchJoken.ADD_TANTO_CD,
      // CYOKUSO_JOGAI: searchJoken.cyokusoCheckbox,
      JOTAI: {
        mishonin: searchJoken.mishoninCheckbox,
        jochoMishonin: searchJoken.jochoMishoninCheckbox,
        shonin: searchJoken.shoninCheckbox,
        jochoShonin: searchJoken.jochoShoninCheckbox,
        hinin: searchJoken.hininCheckbox,
        jochoHininMikakunin: searchJoken.jochoHininMikakuninCheckbox,
        hininMikakunin: searchJoken.hininMikakuninCheckbox,
        jochoHininKakuninzumi: searchJoken.jochoHininKakuninzumiCheckbox,
        hininkakuninzumi: searchJoken.hininKakuninzumiCheckbox,
      },
    },
  }
  if (INP_KBN === HAN_KBN) {
    // FIXME: searchJokenの型を販売条件、倉出条件で同じにする
    const joken = searchJoken as searchJoken
    return {
      ...base,
      searchJoken: {
        ...base.searchJoken,
        TANTO_CD: joken.TANTO_CD,
        // CYOKUSO_JOGAI: false
      },
    }
  }
  if (INP_KBN === KURA_KBN) {
    // FIXME: searchJokenの型を販売条件、倉出条件で同じにする
    // const joken = searchJoken as searchJokenKura
    return {
      ...base,
      searchJoken: {
        ...base.searchJoken,
        TANTO_CD: F_NUM,
        // CYOKUSO_JOGAI: joken.cyokusoCheckbox
      },
    }
  }
  // 修正CSV出力対応 修正出力ボタン追加  20250219 原
  if (INP_KBN === HAN_SYUSEI_KBN) {
    // FIXME: searchJokenの型を販売条件、倉出条件で同じにする
    const joken = searchJoken as searchJoken
    return {
      ...base,
      searchJoken: {
        ...base.searchJoken,
        TANTO_CD: joken.TANTO_CD,
        // CYOKUSO_JOGAI: false
      },
    }
  }
  // 修正CSV出力対応 修正出力ボタン追加  20250221 原
  if (INP_KBN === KURA_SYUSEI_KBN) {
    // FIXME: searchJokenの型を販売条件、倉出条件で同じにする
    const joken = searchJoken as searchJoken
    return {
      ...base,
      searchJoken: {
        ...base.searchJoken,
        TANTO_CD: joken.TANTO_CD,
        // CYOKUSO_JOGAI: false
      },
    }
  }
  // ここには来ない想定
  return {
    ...base,
    searchJoken: {
      ...base.searchJoken,
      TANTO_CD: F_NUM,
      // CYOKUSO_JOGAI: false
    },
  }
}
// /**
//  * 検索項目からリクエストに必要な情報だけに絞り込む処理
//  * @param searchJoken 販売/倉出条件
//  * @returns
//  */
// export const getRequestJokenKuraDetail = (page: number, perPage: number, isHiddenPagination: boolean, INP_KBN: number, MAIL: string, JOKEN_KANRI_NO: string, searchJoken: searchJokenKura): requestJokenKuraDetail => {
//   return {
//     page: isHiddenPagination ? F_NUM : page,
//     perPage: isHiddenPagination ? F_NUM : perPage,
//     INP_KBN: INP_KBN,
//     MAIL: MAIL,
//     TOKUI_CD: searchJoken.TOKUI_CD,
//     JOKEN_KANRI_NO: JOKEN_KANRI_NO,
//     JOTAI: {
//       mishonin: searchJoken.mishoninCheckbox,
//       jochoMishonin: searchJoken.jochoMishoninCheckbox,
//       shonin: searchJoken.shoninCheckbox,
//       jochoShonin: searchJoken.jochoShoninCheckbox,
//       hinin: searchJoken.hininCheckbox,
//       jochoHininMikakunin: searchJoken.jochoHininMikakuninCheckbox,
//       hininMikakunin: searchJoken.hininMikakuninCheckbox,
//       jochoHininKakuninzumi: searchJoken.jochoHininKakuninzumiCheckbox,
//       hininkakuninzumi: searchJoken.hininKakuninzumiCheckbox,
//     },
//   }
// }
/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 販売/倉出条件
 * @returns
 */
export const getRequestJokenDetail = (page: number, perPage: number, isHiddenPagination: boolean, INP_KBN: number, MAIL: string, JOKEN_KANRI_NO: string, searchJoken: searchJoken | searchJokenKura, TANTO_CD: number): requestJokenDetail => {
  const base = {
    page: isHiddenPagination ? F_NUM : page,
    perPage: isHiddenPagination ? F_NUM : perPage,
    INP_KBN: INP_KBN,
    MAIL: MAIL,
    TOKUI_CD: searchJoken.TOKUI_CD,
    JOKEN_KANRI_NO: JOKEN_KANRI_NO,
    // CYOKUSO_JOGAI: searchJoken.cyokusoCheckbox
    JOTAI: {
      mishonin: searchJoken.mishoninCheckbox,
      jochoMishonin: searchJoken.jochoMishoninCheckbox,
      shonin: searchJoken.shoninCheckbox,
      jochoShonin: searchJoken.jochoShoninCheckbox,
      hinin: searchJoken.hininCheckbox,
      jochoHininMikakunin: searchJoken.jochoHininMikakuninCheckbox,
      hininMikakunin: searchJoken.hininMikakuninCheckbox,
      jochoHininKakuninzumi: searchJoken.jochoHininKakuninzumiCheckbox,
      hininkakuninzumi: searchJoken.hininKakuninzumiCheckbox,
    },
    TANTO_CD: TANTO_CD, // 検索では不要だが、全件確認で使用
  }
  if (INP_KBN === HAN_KBN) {
    // FIXME: searchJokenの型を販売条件、倉出条件で同じにする
    return {
      ...base,
      // CYOKUSO_JOGAI: false
    }
  }
  if (INP_KBN === KURA_KBN) {
    // FIXME: searchJokenの型を販売条件、倉出条件で同じにする
    // const joken = searchJoken as searchJokenKura
    return {
      ...base,
      // CYOKUSO_JOGAI: joken.cyokusoCheckbox,
    }
  }

  // ここには来ない想定
  return {
    ...base,
    // CYOKUSO_JOGAI: false
  }
}

// /**
//  * 検索項目からリクエストに必要な情報だけに絞り込む処理
//  * @param searchJoken 販売/倉出条件
//  * @returns
//  */
// export const getRequestJokenKura = (searchJoken: searchJokenKura): requestJokenKura => {
//   return {
//     JOKEN_KANRI_NO: zeroPadding(parseInt(searchJoken.JOKEN_KANRI_NO), 10),
//     KEN_NM: searchJoken.KEN_NM,
//     SIIRE_CD: searchJoken.SIIRE_CD,
//     JIGYO_CD: searchJoken.JIGYO_CD,
//     BUSHO_CD: searchJoken.BUSHO_CD,
//     // TOKUI_CD: searchJoken.TOKUI_CD,
//     // TANTO_CD: searchJoken.TANTO_CD,
//     TEKIYO_START_DT: searchJoken.TEKIYO_START_DT,
//     TEKIYO_END_DT: searchJoken.TEKIYO_END_DT,
//     ADD_TANTO_CD: searchJoken.ADD_TANTO_CD,
//     CYOKUSO_JOGAI: searchJoken.cyokusoCheckbox,
//     JOTAI: {
//       mishonin: searchJoken.mishoninCheckbox,
//       jochoMishonin: searchJoken.jochoMishoninCheckbox,
//       shonin: searchJoken.shoninCheckbox,
//       jochoShonin: searchJoken.jochoShoninCheckbox,
//       hinin: searchJoken.hininCheckbox,
//       jochoHininMikakunin: searchJoken.jochoHininMikakuninCheckbox,
//       hininMikakunin: searchJoken.hininMikakuninCheckbox,
//       jochoHininKakuninzumi: searchJoken.jochoHininKakuninzumiCheckbox,
//       hininkakuninzumi: searchJoken.hininKakuninzumiCheckbox,
//     },
//   }
// }
// export const getRequestJokenKuraDetail = (selectList: string[], jotai: jotai) => {
//   return {
//     KANRI_NOS: selectList,
//     jotai: jotai,
//   }
// }

/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 率条件
 * @returns
 */
export const getRequestJokenRitsu = (MAIL: string, keyInfo: keyInfo[], TANTO_CD: number, isSuperUser: boolean, isJocho: boolean, isKoiki: boolean, page: number, perPage: number, isHiddenPagination: boolean, searchJoken: searchJokenRitsu): requestRitsuSearch => {
  return {
    MAIL: MAIL,
    keyInfo: keyInfo,
    TANTO_CD: TANTO_CD,
    isSuperUser: isSuperUser,
    isJocho: isJocho,
    isKoiki: isKoiki,
    page: isHiddenPagination ? F_NUM : page,
    perPage: isHiddenPagination ? F_NUM : perPage,
    searchJoken: {
      JIGYO_CD: searchJoken.JIGYO_CD, // 事業所コード
      TOKUI_CD: searchJoken.TOKUI_CD, // 得意先コード
      SIIRE_CD: searchJoken.SIIRE_CD, // 仕入先コード
      SYORI_YM_START: searchJoken.SYORI_YM_START,
      SYORI_YM_END: searchJoken.SYORI_YM_END,
      ADD_TANTO_CD: searchJoken.ADD_TANTO_CD,
      JOTAI: {
        mishonin: searchJoken.mishoninCheckbox,
        jochoMishonin: searchJoken.jochoMishoninCheckbox,
        shonin: searchJoken.shoninCheckbox,
        jochoShonin: searchJoken.jochoShoninCheckbox,
        hinin: searchJoken.hininCheckbox,
        jochoHininMikakunin: searchJoken.jochoHininMikakuninCheckbox,
        hininMikakunin: searchJoken.hininMikakuninCheckbox,
        jochoHininKakuninzumi: searchJoken.jochoHininKakuninzumiCheckbox,
        hininkakuninzumi: searchJoken.hininKakuninzumiCheckbox,
      },
    },
  }
}

/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchUser ユーザー登録情報
 * @returns
 */
export const getRequestUser = (searchUser: searchUser, initJigyoCd: number): requestUser => {
  return {
    JIGYO_CD: searchUser.JIGYO_CD === F_NUM ? initJigyoCd : searchUser.JIGYO_CD,
    SIIRE_CD: searchUser.SIIRE_CD,
    USER_NM: searchUser.USER_NM,
    USER_MAIL: searchUser.USER_MAIL,
  }
}
/**
 * 販売条件詳細のCSV出力のリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 販売条件
 * @returns
 */
export const getRequestDetailCSV = (formatNo: number, JOKEN_KANRI_NO: string, TOKUI_CD: number, INP_KBN: number, list: checkListDetail[]): requestDetailCSV => {
  return {
    isSummary: false,
    formatNo: formatNo,
    JOKEN_KANRI_NO: JOKEN_KANRI_NO,
    TOKUI_CD: TOKUI_CD,
    INP_KBN: INP_KBN,
    checkListDetail: list,
  }
}
// 修正CSV出力対応 修正出力ボタン追加  20250219 原
/**
 * 販売条件詳細のCSV出力のリクエストに必要な情報だけに絞り込む処理
 * @param searchJoken 販売条件
 * @returns
 */
export const getRequestDetailCSV_SYUSEI = (formatNo: number, JOKEN_KANRI_NO: string, TOKUI_CD: number, INP_KBN: number, list: checkListDetail[]): requestDetailCSV_SYUSEI => {
  return {
    isSummary: false,
    formatNo: formatNo,
    JOKEN_KANRI_NO: JOKEN_KANRI_NO,
    TOKUI_CD: TOKUI_CD,
    INP_KBN: INP_KBN,
    checkListDetail: list,
  }
}
/**
 * 率条件のチェックデータのリクエストを取得する処理
 * @param searchJoken 率条件
 * @returns
 */
export const getRequestRitsu = (list: checkListRitsu[]): requestRitsu => {
  return {
    checkListRitsu: list,
  }
}
/**
 * 率条件のCSV出力のCSVを取得する処理
 * @param searchJoken 率条件
 * @returns
 */
export const getRequestRitsuCSV = (formatNo: number, list: checkListRitsu[]): requestRitsuCSV => {
  return {
    formatNo: formatNo,
    checkListRitsu: list,
  }
}
/**
 * 率条件のCSV出力のCSVを取得する処理
 * @param searchJoken 率条件
 * @returns
 */
export const getRequestRitsuCSVAll = (formatNo: number, requestRitsuSearch: requestRitsuSearch): requestRitsuAllCSV => {
  return {
    formatNo: formatNo,
    requestRitsuSearch: requestRitsuSearch,
  }
}
/**
 * ユーザー登録に必要なリクエストを取得する処理
 * @param searchJoken 率条件
 * @returns
 */
export const getRequestUserUpdate = (JIGYO_CD: number, TOKUI_CD: number, TANTO_CD: number, checkListSummaryUser: checkListSummaryUser[], isNeededCheck: boolean): requestUserUpdate => {
  return {
    JIGYO_CD: JIGYO_CD,
    TOKUI_CD: TOKUI_CD,
    TANTO_CD: TANTO_CD,
    checkListSummaryUser: checkListSummaryUser,
    isNeededCheck: isNeededCheck,
  }
}

/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchLog ログ
 * @returns
 */
export const getRequestLog = (searchLog: searchLog): requestLog => {
  return {
    JIGYO_CD: searchLog.JIGYO_CD,
    SIIRE_CD: searchLog.SIIRE_CD,
    TOKUI_CD: searchLog.TOKUI_CD,
    TANTO_CD: searchLog.TANTO_CD,
    DT_FROM: searchLog.DT_FROM > 0 ? Number(zeroPaddingRight(searchLog.DT_FROM, 14)) : searchLog.DT_FROM, // 入力は分までなので秒までにして渡す
    DT_TO: searchLog.DT_TO > 0 ? Number(zeroPaddingRight(searchLog.DT_TO, 14)) : searchLog.DT_TO, // 入力は分までなので秒までにして渡す
    MAIL: searchLog.MAIL,
    torokuCheckbox: searchLog.torokuCheckbox,
    sakujoCheckbox: searchLog.sakujoCheckbox,
  }
}

/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchTenyuryoku 手入力照会
 * @returns
 */
export const getRequestTenyuryoku = (MAIL: string, keyInfo: keyInfo[], TANTO_CD: number, isSuperUser: boolean, isJocho: boolean, isKoiki: boolean, page: number, perPage: number, isHiddenPagination: boolean, searchTenyuryoku: searchTenyuryoku): requestTenyuryokuSummary => {
  return {
    MAIL: MAIL,
    keyInfo: keyInfo,
    TANTO_CD: TANTO_CD,
    isSuperUser: isSuperUser,
    isJocho: isJocho,
    isKoiki: isKoiki,
    page: isHiddenPagination ? F_NUM : page,
    perPage: isHiddenPagination ? F_NUM : perPage,
    searchTenyuryoku: {
      SYORI_YMD_FROM: searchTenyuryoku.SYORI_YMD_FROM,
      SYORI_YMD_TO: searchTenyuryoku.SYORI_YMD_TO,
      ADD_YMD_FROM: searchTenyuryoku.ADD_YMD_FROM,
      ADD_YMD_TO: searchTenyuryoku.ADD_YMD_TO,
      NYUKIN_YMD_FROM: searchTenyuryoku.NYUKIN_YMD_FROM,
      NYUKIN_YMD_TO: searchTenyuryoku.NYUKIN_YMD_TO,
      SIIRE_CD: searchTenyuryoku.SIIRE_CD,
      JIGYO_CD: searchTenyuryoku.JIGYO_CD,
      TANTO_CD: searchTenyuryoku.TANTO_CD,
      NAIYO_KBN1: searchTenyuryoku.NAIYO_KBN1,
      NAIYO_KBN2: searchTenyuryoku.NAIYO_KBN2,
      SEISAN_KOUMOKU: searchTenyuryoku.SEISAN_KOUMOKU,
      DENPYO_NO: searchTenyuryoku.DENPYO_NO,
      SEISAN_NAIYO: searchTenyuryoku.SEISAN_NAIYO,
      JOTAI: {
        mishonin: searchTenyuryoku.mishoninCheckbox,
        jochoMishonin: searchTenyuryoku.jochoMishoninCheckbox,
        shonin: searchTenyuryoku.shoninCheckbox,
        jochoShonin: searchTenyuryoku.jochoShoninCheckbox,
        hinin: searchTenyuryoku.hininCheckbox,
        jochoHininMikakunin: searchTenyuryoku.jochoHininMikakuninCheckbox,
        hininMikakunin: searchTenyuryoku.hininMikakuninCheckbox,
        jochoHininKakuninzumi: searchTenyuryoku.jochoHininKakuninzumiCheckbox,
        hininkakuninzumi: searchTenyuryoku.hininKakuninzumiCheckbox,
      },
    },
  }
}
/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchTenyuryoku 手入力照会
 * @returns
 */
export const getRequestTenyuryokuDetail = (userKind: number, MAIL: string, TANTO_CD: number, DENPYO_NO: string, JOTAI: jotai, TOKUI_CDS: number[], page: number, perPage: number, isHiddenPagination: boolean): requestTenyuryokuDetail => {
  return {
    MAIL: MAIL,
    TANTO_CD: TANTO_CD,
    userKind: userKind,
    page: isHiddenPagination ? F_NUM : page,
    perPage: isHiddenPagination ? F_NUM : perPage,
    DENPYO_NO: DENPYO_NO,
    JOTAI: JOTAI,
    TOKUI_CDS: TOKUI_CDS,
  }
}

// ユーザ一覧CSV出力対応 CSV出力ボタン追加 20250303 原
/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchUser ユーザー登録情報
 * @returns
 */
export const getRequestDetailUserCSV = (formatNo: number, MAIL: string, JIGYO_CD: number, SIIRE_CD: number, /*TOKUI_CD:number,*/ list: checkListDetailUser[]): requestDetailUserCSV => {
  return {
    isSummary: false,
    formatNo: formatNo,
    MAIL: MAIL,
    JIGYO_CD: JIGYO_CD,
    SIIRE_CD: SIIRE_CD,
    // TOKUI_CD: TOKUI_CD,
    checkListDetailUser: list,
  }
}

// ユーザ一覧CSV出力対応 CSV出力ボタン追加 20250303 原
/**
 * 検索項目からリクエストに必要な情報だけに絞り込む処理
 * @param searchUser ユーザー登録情報
 * @returns
 */
export const getRequestSummaryUserCSV = (formatNo: number, MAIL: string, JIGYO_CD: number, SIIRE_CD: number, /*TOKUI_CD:number,*/ list: checkListSummaryUser[]): requestSummaryUserCSV => {
  return {
    isSummary: true,
    formatNo: formatNo,
    MAIL: MAIL,
    JIGYO_CD: JIGYO_CD,
    SIIRE_CD: SIIRE_CD,
    // TOKUI_CD: TOKUI_CD,
    checkListSummaryUser: list,
  }
}
